import fetch from 'cross-fetch';
import { action } from 'typesafe-actions';
import { Tokenizer } from '@fnv-core/tokens';
import { Alert } from '../models/Alert';
import { STORE_ALERT, CLEAR_ALERTS } from '../constants/Constants';
import { reformatUrlRelativePaths } from '@fnv-core/utils';

export const storeAlert = (title: string, type : string, link : string, linkText: string) => action(STORE_ALERT, 
  {
    title : title, 
    type : type, 
    link : link,
    linkText : linkText
  } as Alert);

export const clearAlert = () => action(CLEAR_ALERTS);
  
export const getAlertsViaApi = (url : string, userId : string) => dispatch => {
  let formattedUrl = Tokenizer.replaceTokens(url, [userId]);
  formattedUrl = reformatUrlRelativePaths(formattedUrl);
  return fetch(formattedUrl)
    .then(response => response.json())
    .then(json => {
        dispatch(clearAlert());
        json.map((item) => dispatch(
            storeAlert(
              item.Title,
              item.Type,
              item.Link || "",
              item.LinkText || ""
            )
          )
        );
      }  
    );
};